<template>
	<main >
    <div v-if="!$store.state.user" class="Auth">
        <form @submit.prevent="handleSubmit">
            <h1>IPUMON Admin</h1>
            <h3><b>Login</b></h3>

            <label for="email">Email:</label>
            <input type="email" name="email" v-model="email" required>

            <label for="email">Password:</label>
            <input type="password" name="password" v-model="password" required>

            <div v-if="error">{{ error }}</div>
            <button >Login</button>
            <p>Looking for member login, <a href="http://ipumon.org/auth/login">login here</a>. Looking for IPUMON main site, <a href="http://ipumon.com/">see here.</a></p>
            <p>AuthPass: Ver Beta-0.0.10</p>
        </form>
    </div>
    <div v-if="$store.state.user" class="Auth">
        <form @submit.prevent="handleSubmit">
            <h3>An Error Occurred</h3>
            <p>This error will fix in the come up updates, click the bottom and/or footer link below or the navbar above.</p>
            <a href="/admin">Go home page</a>
        </form>
    </div>
	</main>
</template>

<script>
// import { ref } from 'vue'
// // import { useStore } from 'vuex'
// export default {
// 	// setup () {
// 	// 	const login_form = ref({});
// 	// 	const store = useStore();
// 	// 	const login = () => {
// 	// 		store.dispatch('login', login_form.value);
// 	// 	}
		
// 	// 	return {
// 	// 		login_form,
// 	// 		login,
// 	// 	}
// 	// }
// }
import { ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
export default {
  setup() {
    const email = ref('')
    const password = ref('')
    const error = ref(null)
    const store = useStore()
    const router = useRouter()
    const handleSubmit = async () => {
      try {
        await store.dispatch('login', {
          email: email.value,
          password: password.value
        })
        router.push('/admin/ads-managment')
      }
      catch (err) {
        error.value = err.message
      }
    }
    return { handleSubmit, email, password, error }
  }
}
</script>

<style>
.Auth h1 {
	margin-right: 100%;
	letter-spacing: 5px;
}
.Auth h3 {
	margin-right: 100%;
	letter-spacing: 3px;
}
.Auth form { 
	background: lightgray; 
	max-width: 50%; 
	margin: 100px auto 16px; 
	padding: 32px 24px 16px; 
	border-radius: 3px; }
.Auth input[type=email], input[type=password] {
	width: 100%; 
	padding: 12px 20px;  
	margin: 8px 0; 
	display: inline-block;  
	border: 1px solid #ccc; 
	box-sizing: border-box;}
.Auth button {
  background-color: #04AA6D;
  color: white;
  padding: 14px 20px;
  margin: 8px 0;
  border: none;
  cursor: pointer;
  width: 100%;
}
  @media (max-width: 800px) {
      form { max-width: 250px;}
    }
</style>